export default (state) => {
  const item = state.activeSubMenuItem || state.activeMenuItem;
  const type = state.activeMenuItem ? 'mainMenu' : 'subMenu';

  return {
    type, item,
  };
};
